import { FETCH_BUSINESS_LIST,FETCH_STATE_LIST ,FETCH_PINCODE_LIST, FETCH_CITY_LIST} from 'src/constants';
import { BUSINESS_DETAILS_URL } from 'src/constants/services';
import axios from 'src/utils/axios';

class BusinessService {
    // Fetches the pincode list for a given stdCode
  fetchPincodeList = (cityCode) => new Promise((resolve, reject) => {
   
    axios
      .get(FETCH_PINCODE_LIST(cityCode))
      .then((response) => {
        if (response.data) {
          // Adjust extraction based on your API response structure.
          resolve(response.data); 
        } else {
          reject(response.data.error);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

  // Fetches the state list from the ONDC master endpoint.
  fetchStateList = () => new Promise((resolve, reject) => {
    axios
      .get(FETCH_STATE_LIST)
      .then((response) => {
        if (response.data) {
          // Adjust the data path as needed based on your API response structure.
          let stateList = response.data?.data;
          resolve(stateList);
        } else {
          reject(response.data.error);
        }
      })
      .catch((error) => {
        reject(error);
      });
  })
  // Fetches the city list for a given state code.
  fetchCityList = (stateCode) => new Promise((resolve, reject) => {
    axios
      .get(FETCH_CITY_LIST(stateCode))
      .then((response) => {
        if (response.data) {
          let cityList = response.data?.data;
          resolve(cityList);
        } else {
          reject(response.data.error);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

  fetchBusinesses = () => new Promise((resolve, reject) => {
    axios
      .get(FETCH_BUSINESS_LIST)
      .then((response) => {
        // console.log("MgmtUser(fetchUsers->Response): 1", response);
        if (response.data) {
          let businesses = response.data?.data?.customerList;
          // console.log("MgmtUser(fetchUsers)", users);
          resolve(businesses);
        } else {
          reject(response.data.error);
        }
      })
      .catch((error) => {
        //console.log("MgmtUser.createUser (Response Error):" + JSON.stringify(error));
        reject(error);
      });
  })


  fetchBusinessDetails = ( customerId) => new Promise((resolve, reject) => {
    axios
      .get(`${BUSINESS_DETAILS_URL}?customerId=${customerId}`)
      .then((response) => {
        // console.log("MgmtUser(fetchUsers->Response): 1", response);
        if (response.data) {
          let business = response.data?.data;
          // console.log("MgmtUser(fetchUsers)", users);
          resolve(business);
        } else {
          reject(response.data.error);
        }
      })
      .catch((error) => {
        //console.log("MgmtUser.createUser (Response Error):" + JSON.stringify(error));
        reject(error);
      });
  })

}

const businessService = new BusinessService();
export default businessService;
